import React, { useState } from "react";
import { Container, TextField, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import { useErrorHandler } from "../../../hooks/useErrorHandler";

function RegisterAdmin() {
  const [adminData, setAdminData] = useState({
    full_name: "",
    email: "",
    password: "",
    confirm_password: "",
  });

  const navigate = useNavigate();
  const { handleError, showSuccess } = useErrorHandler();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdminData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (adminData.password !== adminData.confirm_password) {
      handleError(new Error("Пароли не совпадают"));
      return;
    }
    try {
      const { full_name, email, password } = adminData;
      const dataToSend = { full_name, email, password };

      await api.post("/admin/register", dataToSend);
      showSuccess("Администратор успешно зарегистрирован!");

      // Переход на админ-панель после успешной регистрации
      setTimeout(() => {
        navigate("/admin-panel");
      }, 1500); // Задержка для показа уведомления
    } catch (error) {
      // Используем ErrorService для детальной обработки ошибки
      handleError(error, "Ошибка при регистрации администратора");
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        Регистрация администратора
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Полное имя"
          name="full_name"
          value={adminData.full_name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={adminData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Пароль"
          name="password"
          type="password"
          value={adminData.password}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Подтверждение пароля"
          name="confirm_password"
          type="password"
          value={adminData.confirm_password}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <Button variant="contained" color="primary" type="submit" fullWidth>
          Зарегистрироваться
        </Button>
      </form>
    </Container>
  );
}

export default RegisterAdmin;
